export default function currentUserReducer(state = null, action) {
  switch (action.type) {
    case "CURRENT_USER_FETCHED":
    case "CURRENT_USER_REMOVED":
      return action.id;
    default:
      return state;
  }
}
